// Duo-valet vid köpknappen: byter variant-id i köpformuläret och priset ovanför knappen.
class LenoitesDuo extends HTMLElement {
  connectedCallback() {
    const wrap = this.closest('.wt-product__add-to-cart_form');
    const form = wrap?.querySelector('form[data-type="add-to-cart-form"]');
    const id = form?.querySelector('input[name="id"]');
    const fieldset = this.querySelector('fieldset');
    if (!form || !id || !fieldset) return;

    const priceBox = this.closest('.shopify-section')?.querySelector('.wt-product__price');
    let duoPrice;
    if (priceBox) {
      duoPrice = document.createElement('span');
      duoPrice.className = 'price-item price-item--regular wt-product__price__final lenoites-duo-pris';
      duoPrice.hidden = true;
      priceBox.append(duoPrice);
    }

    const radios = this.querySelectorAll('input[type="radio"]');
    const packageChoice = radios[1];
    const packageSelect = this.querySelector('select');
    const updatePackage = () => {
      const option = packageSelect?.selectedOptions[0];
      if (!option) return;
      packageChoice.value = option.value;
      Object.assign(packageChoice.dataset, option.dataset);
      this.querySelector('[data-duo-title]').textContent = option.dataset.title;
      this.querySelector('[data-duo-price]').textContent = option.dataset.price;
      const saving = this.querySelector('[data-duo-saving]');
      saving.textContent = option.dataset.saving;
      saving.hidden = !option.dataset.saving;
    };

    const sync = () => {
      updatePackage();
      const choice = this.querySelector('input:checked');
      if (!choice) return;
      const single = choice === radios[0];
      const picker = this.querySelector('.lenoites-duo__variant');
      if (picker) picker.hidden = single;
      id.value = choice.value;
      if (priceBox) {
        priceBox.classList.toggle('lenoites-duo-vald', !single);
        duoPrice.textContent = choice.dataset.price;
        duoPrice.hidden = single;
      }
      this.dispatchEvent(new CustomEvent('lenoites:purchase-change', {
        bubbles: true, detail: { price: Number(choice.dataset.priceCents) },
      }));
    };

    this.addEventListener('change', (event) => {
      if (event.target === packageSelect) packageChoice.checked = true;
      sync();
    });

    // PowerLash: färgvalet byter mascaran i båda valen och duon i samma färg.
    const map = this.querySelector('[data-duo-varianter]');
    if (map) {
      const varianter = JSON.parse(map.textContent);
      const section = this.closest('.shopify-section');
      section?.addEventListener('variantChangeEnd', (event) => {
        const v = varianter[String(event.target.currentVariant?.id)];
        if (!v) return;
        Object.assign(radios[0], { value: event.target.currentVariant.id });
        Object.assign(radios[0].dataset, { price: v.price, priceCents: v.cents });
        radios[0].nextElementSibling.querySelector('strong').textContent = v.price;
        packageChoice.value = v.duo;
        Object.assign(packageChoice.dataset, { price: v.duoPrice, priceCents: v.duoCents });
        packageChoice.disabled = !v.duoAvailable;
        if (!v.duoAvailable) radios[0].checked = true;
        this.querySelector('[data-duo-price]').textContent = v.duoPrice;
        const saving = this.querySelector('[data-duo-saving]');
        saving.textContent = v.saving;
        saving.hidden = !v.saving;
        sync();
      });
      // Temat skriver om prisrutan efter färgbyte, då läggs duopriset tillbaka.
      if (priceBox) {
        new MutationObserver(() => {
          if (!duoPrice.isConnected) { priceBox.append(duoPrice); sync(); }
        }).observe(priceBox, { childList: true });
      }
    }
    window.addEventListener('pageshow', sync);
    fieldset.disabled = false;
    sync();
  }
}

if (!customElements.get('lenoites-duo')) customElements.define('lenoites-duo', LenoitesDuo);
